import { TableCell, TableRow, Typography } from '@mui/material'
import { ReactNode } from 'react'

export type TableNoDataRowProps = {
  colSpan: number
  message?: ReactNode
  children?: ReactNode
}

export const TableNoDataRow = ({ colSpan, message, children }: TableNoDataRowProps): JSX.Element => (
  <TableRow>
    <TableCell colSpan={colSpan} sx={{ textAlign: 'center', py: 4, border: 'none' }}>
      {children ?? (
        <Typography color="textPrimary" variant="body1">
          {message}
        </Typography>
      )}
    </TableCell>
  </TableRow>
)
